import { useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import { setDocumentTitle } from "@/lib/documentTitle";

import { L1DataUploadTable } from "./table";
import { L1DataUploadEdit } from "./edit";

export default function L1DataUpload() {
  useEffect(() => {
    setDocumentTitle("Quantilia | Chargement de fichiers");
  }, []);

  return (
    <Routes>
      <Route path=":id" element={<L1DataUploadEdit />} />
      <Route index element={<L1DataUploadTable />} />
    </Routes>
  );
}
